import { render } from "./UiInput.vue?vue&type=template&id=b70d007e&ts=true"
import script from "./UiInput.vue?vue&type=script&lang=ts"
export * from "./UiInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__